import { useEffect } from "react";
import { useTranslation } from "react-i18next";

// Wraps a route to render it in a specific i18next language for the
// duration of that route, then restores the previous language on
// unmount - so navigating away (e.g. via the header, which isn't
// translated yet) doesn't leave the rest of the app stuck in "pt".
// This is deliberately per-route rather than a global switcher: only
// pages wrapped here actually have translations to switch to.
function LanguageRoute({ lang, children }: { lang: string; children: React.ReactNode }) {
    const { i18n } = useTranslation();

    useEffect(() => {
        const previousLang = i18n.language;
        i18n.changeLanguage(lang);
        return () => {
            i18n.changeLanguage(previousLang);
        };
    }, [lang, i18n]);

    return <>{children}</>;
}

export default LanguageRoute;
